<template>
    <div>
        <v-col cols="12" class="tabs">
            <h2 class="mt-4">{{ t('patients::page.title.patients') }}</h2>
            <v-tabs v-model="tab" show-arrows>
                <v-tab v-for="item in items" :key="item">
                    <div class="tab">
                        {{ item }}
                    </div>
                </v-tab>
                <v-tab>
                    <div class="tab">
                        {{ t('patients::tabs.button.search_memo') }}
                    </div>
                </v-tab>
                <v-tab-item v-for="(item, index) in items" :key="index * 3">
                    <patients-data-table
                        ref="grid"
                        :initial-filters="initialFilters"
                        :list-route="trueListRoute"
                        :has-pharmacy-site="!!initialFilters.hasOwnProperty('pharmacy_site_id')"
                        :grid-title="item"
                        :keep-filters-prefix="keepFiltersPrefix"
                    ></patients-data-table>
                </v-tab-item>
                <v-tab-item>
                    <patients-memos-data-table
                        ref="grid"
                        :initial-filters="initialMemoFilters"
                        :list-route="trueListRoute"
                        :has-pharmacy-site="!!initialMemoFilters.hasOwnProperty('pharmacy_site_id')"
                        :grid-title="t('patients::tabs.button.search_memo')"
                        :keep-filters-prefix="memosKeepFiltersPrefix"
                    ></patients-memos-data-table>
                </v-tab-item>
            </v-tabs>
        </v-col>
    </div>
</template>

<script>
import PatientsMemosDataTable from './partials/PatientsMemosDataTable.vue';

export default {
    components: { PatientsMemosDataTable },
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        let searchParams = new URLSearchParams(window.location.search);
        let pharmacySiteId = searchParams.get('pharmacy_site_id');

        return {
            tab: null,
            items: [t('patients::tabs.button.all'), t('patients::tabs.button.red_alerted')],
            keepFiltersPrefix: pharmacySiteId ? pharmacySiteId : 'patients',
            memosKeepFiltersPrefix: pharmacySiteId ? pharmacySiteId : 'memos',
            initialFilters: {
                is_registered: 1,
                health_status: null,
                max_dispensing: null,
                validity: null,
                status: null,
                cnrd_date: null,
                prohibited: null,
                has_treatment_break: null,
                dispensed: null,
            },
            initialMemoFilters: {
                is_registered: 1,
                health_status: null,
                max_dispensing: null,
                validity: null,
                status: null,
                cnrd_date: null,
                prohibited: null,
                has_treatment_break: null,
                dispensed: null,
                memo_date: [moment().subtract(14, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
            },
            // patientsDataTableItems: [{ isRedAlert: false }, { isRedAlert: true }],
        };
    },
    computed: {
        trueListRoute() {
            if (this.tab === 2) {
                return route('api.v1.patients.memos');
            }

            return this.listRoute;
        },
    },
    watch: {
        tab: function (val) {
            this.$store.dispatch('data_table/changeTab', val);
            this.initialFilters.color = val === 1 ? 'red' : null;
            const searchParams = new URLSearchParams(window.location.search);
            const pharmacySiteId = searchParams.get('pharmacy_site_id') || '';
            const redAlertedSuffix = `red_alerted_patients_${pharmacySiteId}`;
            const patientsSuffix = `patients_${pharmacySiteId}`;

            this.keepFiltersPrefix = val === 1 ? redAlertedSuffix : patientsSuffix;
            _.delay(() => {
                window.dispatchEvent(new Event('scroll'));
                if (this.$refs.grid[val]) {
                    this.$refs.grid[val].changeTab();
                }
            }, 200);
        },
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        for (const key of urlParams.keys()) {
            this.initialFilters[key] = urlParams.get(key);
            if (key === 'pharmacy_site_id') {
                this.getPharmacySiteName(urlParams.get(key))
                    .then((item) => this.$root.breadcrumbs.push(item))
                    .catch((item) => this.$root.breadcrumbs.push(item));
            }
        }
    },
    methods: {
        getPharmacySiteName(id) {
            return axios
                .get(
                    route('api.v1.pharmacy-sites.show', {
                        pharmacy_site: id,
                        fields: 'id,site_name',
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    return new Object({
                        text: response.data.data.site_name,
                        disabled: false,
                        href: route('pharmacy-sites.get', { id: response.data.data.id }),
                    });
                })
                .catch(() => {
                    return new Object({
                        text: t('patients::form.label.pharmacy_site'),
                        disabled: true,
                        href: null,
                    });
                });
        },
    },
};
</script>

<style></style>
